import React, { useState } from 'react';
import axios from 'axios';
import { TextField, Button, Typography } from '@mui/material';
import { useAuth } from '../AuthContext';

const NewFAQ = () => {
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [successMessage, setSuccessMessage] = useState(''); // Add state for success message
  const [error, setError] = useState(''); // Add state for error message
  const { token } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        'https://sirius.runasp.net/api/FAQ',
        {
          question,
          answer,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // Reset form fields and show success message
      setQuestion('');
      setAnswer('');
      setSuccessMessage('FAQ added successfully!');
      setError(''); // Clear error message if any

      setTimeout(() => setSuccessMessage(''), 3000); // Clear message after 3 seconds
    } catch (error) {
      console.error('There was an error adding the FAQ!', error);
      setError(`Failed to add FAQ. Error: ${error.response?.data?.message || error.message}`);
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '1rem' }}>
      <TextField
        label="Question"
        value={question}
        onChange={(e) => setQuestion(e.target.value)}
        required
        fullWidth
        margin="normal"
      />
      <TextField
        label="Answer"
        value={answer}
        onChange={(e) => setAnswer(e.target.value)}
        required
        fullWidth
        margin="normal"
      />
      {successMessage && (
        <Typography color="success" variant="body2" style={{ color: 'green', margin: '1rem 0' }}>
          {successMessage}
        </Typography>
      )}
      {error && (
        <Typography color="error" variant="body2" style={{ color: 'red', margin: '1rem 0' }}>
          {error}
        </Typography>
      )}
      <Button type="submit" variant="contained" color="primary">
        Add FAQ
      </Button>
    </form>
  );
};

export default NewFAQ;
